import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


/* ScrollTrigger.normalizeScroll(true); */



export default class ScrollFunc {
    constructor() {
        this.isTop = true;
        this.init();
    }

    init() {
        this._handleTabletChange();

        this.setToggleClassOnceReveal();
        this.setToggleClassOnceFunc();
        this.smoothScroll();
        this.smoothScrollOtherPage();
    }

    _handleTabletChange() {
        if (document.body.classList.contains("top")) {
            this.isTop = true;
        } else {
            this.isTop = false;
        }
    }

    setToggleClassOnceReveal() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add("-reveal");
                    observer.unobserve(entry.target);
                }
            });
        });

        [...document.querySelectorAll(".js-scrollreveal")].forEach(
            ($target) => {
                observer.observe($target);
            }
        );
    }

    setToggleClassOnceFunc() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add("-scrollfunc");
                    observer.unobserve(entry.target);
                }
            });
        });

        [...document.querySelectorAll(".js-scrollfunc")].forEach(($target) => {
            observer.observe($target);
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll(".js-smoothscroll");

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();

                const hash = el.getAttribute("href");     

                const offset =
                    window.innerWidth <= 1019
                        ? window.innerWidth * 0.3
                        : 200 * (window.innerWidth / 1920);
                gsap.to(window, {
                    duration: 1,
                    scrollTo: { y: hash, offsetY: offset, autoKill: false },
                    ease: "circ.inOut",
                    normalizeScroll: false,
                });
            });
        });
    }

    smoothScrollOtherPage() {
        const urlHash = location.hash;
        if (!this.isTop) return;


        window.addEventListener("load", () => {
            const offset =
                window.innerWidth <= 1019
                    ? window.innerWidth * 0.3
                    : 200 * (window.innerWidth / 1920);
            gsap.to(window, {
                duration: 1,
                scrollTo: { y: urlHash, offsetY: offset, autoKill: false },
                ease: "circ.inOut",
                normalizeScroll: false,
            });
        });
        
    }
}
